import { render, staticRenderFns } from "./DocumentExpirationDate.vue?vue&type=template&id=9bfb8c46&scoped=true&"
import script from "./DocumentExpirationDate.vue?vue&type=script&lang=js&"
export * from "./DocumentExpirationDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bfb8c46",
  null
  
)

export default component.exports